export const TrafficControl = {
  xOffset: 0,
  yOffset: 0,
  pixels: [
    {
      x: 29,
      y: 8
    },
    {
      x: 30,
      y: 8
    },
    {
      x: 31,
      y: 8
    },
    {
      x: 36,
      y: 5
    },
    {
      x: 37,
      y: 5
    },
    {
      x: 38,
      y: 5
    },
    {
      x: 39,
      y: 5
    },
    {
      x: 37,
      y: 8
    },
    {
      x: 38,
      y: 8
    },
    {
      x: 36,
      y: 8
    },
    {
      x: 43,
      y: 5
    },
    {
      x: 44,
      y: 5
    },
    {
      x: 43,
      y: 11
    },
    {
      x: 44,
      y: 11
    },
    {
      x: 16,
      y: 8
    },
    {
      x: 16,
      y: 9
    },
    {
      x: 16,
      y: 5
    },
    {
      x: 15,
      y: 5
    },
    {
      x: 15,
      y: 8
    },
    {
      x: 11,
      y: 5
    },
    {
      x: 10,
      y: 5
    },
    {
      x: 9,
      y: 5
    },
    {
      x: 8,
      y: 5
    },
    {
      x: 29,
      y: 17
    },
    {
      x: 29,
      y: 18
    },
    {
      x: 29,
      y: 19
    },
    {
      x: 29,
      y: 20
    },
    {
      x: 29,
      y: 21
    },
    {
      x: 29,
      y: 22
    },
    {
      x: 29,
      y: 23
    },
    {
      x: 30,
      y: 23
    },
    {
      x: 30,
      y: 22
    },
    {
      x: 30,
      y: 21
    },
    {
      x: 30,
      y: 20
    },
    {
      x: 30,
      y: 19
    },
    {
      x: 30,
      y: 18
    },
    {
      x: 30,
      y: 17
    },
    {
      x: 31,
      y: 17
    },
    {
      x: 32,
      y: 17
    },
    {
      x: 28,
      y: 17
    },
    {
      x: 27,
      y: 17
    },
    {
      x: 34,
      y: 17
    },
    {
      x: 34,
      y: 18
    },
    {
      x: 34,
      y: 19
    },
    {
      x: 34,
      y: 20
    },
    {
      x: 34,
      y: 21
    },
    {
      x: 34,
      y: 22
    },
    {
      x: 34,
      y: 23
    },
    {
      x: 35,
      y: 17
    },
    {
      x: 35,
      y: 18
    },
    {
      x: 35,
      y: 19
    },
    {
      x: 35,
      y: 20
    },
    {
      x: 35,
      y: 21
    },
    {
      x: 35,
      y: 22
    },
    {
      x: 35,
      y: 23
    },
    {
      x: 36,
      y: 17
    },
    {
      x: 37,
      y: 17
    },
    {
      x: 38,
      y: 17
    },
    {
      x: 38,
      y: 18
    },
    {
      x: 39,
      y: 18
    },
    {
      x: 38,
      y: 19
    },
    {
      x: 39,
      y: 19
    },
    {
      x: 36,
      y: 20
    },
    {
      x: 37,
      y: 20
    },
    {
      x: 37,
      y: 21
    },
    {
      x: 38,
      y: 21
    },
    {
      x: 38,
      y: 22
    },
    {
      x: 39,
      y: 22
    },
    {
      x: 39,
      y: 23
    },
    {
      x: 41,
      y: 18
    },
    {
      x: 41,
      y: 19
    },
    {
      x: 41,
      y: 20
    },
    {
      x: 41,
      y: 21
    },
    {
      x: 41,
      y: 22
    },
    {
      x: 42,
      y: 23
    },
    {
      x: 42,
      y: 22
    },
    {
      x: 42,
      y: 21
    },
    {
      x: 42,
      y: 20
    },
    {
      x: 42,
      y: 19
    },
    {
      x: 42,
      y: 18
    },
    {
      x: 42,
      y: 17
    },
    {
      x: 43,
      y: 17
    },
    {
      x: 44,
      y: 17
    },
    {
      x: 45,
      y: 17
    },
    {
      x: 43,
      y: 23
    },
    {
      x: 44,
      y: 23
    },
    {
      x: 45,
      y: 23
    },
    {
      x: 45,
      y: 21
    },
    {
      x: 45,
      y: 22
    },
    {
      x: 45,
      y: 20
    },
    {
      x: 45,
      y: 19
    },
    {
      x: 45,
      y: 18
    },
    {
      x: 46,
      y: 18
    },
    {
      x: 46,
      y: 19
    },
    {
      x: 46,
      y: 20
    },
    {
      x: 46,
      y: 21
    },
    {
      x: 46,
      y: 22
    },
    {
      x: 48,
      y: 17
    },
    {
      x: 49,
      y: 17
    },
    {
      x: 48,
      y: 18
    },
    {
      x: 49,
      y: 18
    },
    {
      x: 48,
      y: 19
    },
    {
      x: 49,
      y: 19
    },
    {
      x: 48,
      y: 20
    },
    {
      x: 49,
      y: 20
    },
    {
      x: 49,
      y: 21
    },
    {
      x: 48,
      y: 21
    },
    {
      x: 48,
      y: 22
    },
    {
      x: 49,
      y: 22
    },
    {
      x: 48,
      y: 23
    },
    {
      x: 49,
      y: 23
    },
    {
      x: 50,
      y: 23
    },
    {
      x: 51,
      y: 23
    },
    {
      x: 52,
      y: 23
    },
    {
      x: 25,
      y: 17
    },
    {
      x: 25,
      y: 18
    },
    {
      x: 25,
      y: 19
    },
    {
      x: 25,
      y: 20
    },
    {
      x: 25,
      y: 21
    },
    {
      x: 25,
      y: 22
    },
    {
      x: 25,
      y: 23
    },
    {
      x: 24,
      y: 23
    },
    {
      x: 24,
      y: 22
    },
    {
      x: 24,
      y: 21
    },
    {
      x: 24,
      y: 20
    },
    {
      x: 24,
      y: 19
    },
    {
      x: 24,
      y: 18
    },
    {
      x: 24,
      y: 17
    },
    {
      x: 21,
      y: 17
    },
    {
      x: 21,
      y: 18
    },
    {
      x: 21,
      y: 19
    },
    {
      x: 21,
      y: 20
    },
    {
      x: 21,
      y: 21
    },
    {
      x: 21,
      y: 22
    },
    {
      x: 21,
      y: 23
    },
    {
      x: 20,
      y: 23
    },
    {
      x: 20,
      y: 22
    },
    {
      x: 20,
      y: 21
    },
    {
      x: 20,
      y: 20
    },
    {
      x: 20,
      y: 19
    },
    {
      x: 20,
      y: 18
    },
    {
      x: 20,
      y: 17
    },
    {
      x: 22,
      y: 19
    },
    {
      x: 23,
      y: 20
    },
    {
      x: 18,
      y: 18
    },
    {
      x: 18,
      y: 19
    },
    {
      x: 18,
      y: 20
    },
    {
      x: 18,
      y: 21
    },
    {
      x: 18,
      y: 22
    },
    {
      x: 17,
      y: 23
    },
    {
      x: 17,
      y: 22
    },
    {
      x: 17,
      y: 21
    },
    {
      x: 17,
      y: 20
    },
    {
      x: 17,
      y: 19
    },
    {
      x: 17,
      y: 18
    },
    {
      x: 17,
      y: 17
    },
    {
      x: 16,
      y: 17
    },
    {
      x: 15,
      y: 17
    },
    {
      x: 14,
      y: 17
    },
    {
      x: 14,
      y: 18
    },
    {
      x: 14,
      y: 19
    },
    {
      x: 14,
      y: 20
    },
    {
      x: 14,
      y: 22
    },
    {
      x: 14,
      y: 21
    },
    {
      x: 14,
      y: 23
    },
    {
      x: 15,
      y: 23
    },
    {
      x: 16,
      y: 23
    },
    {
      x: 13,
      y: 22
    },
    {
      x: 13,
      y: 21
    },
    {
      x: 13,
      y: 20
    },
    {
      x: 13,
      y: 19
    },
    {
      x: 13,
      y: 18
    },
    {
      x: 11,
      y: 18
    },
    {
      x: 10,
      y: 18
    },
    {
      x: 10,
      y: 17
    },
    {
      x: 9,
      y: 17
    },
    {
      x: 8,
      y: 17
    },
    {
      x: 7,
      y: 17
    },
    {
      x: 7,
      y: 18
    },
    {
      x: 7,
      y: 19
    },
    {
      x: 7,
      y: 20
    },
    {
      x: 7,
      y: 21
    },
    {
      x: 7,
      y: 22
    },
    {
      x: 7,
      y: 23
    },
    {
      x: 6,
      y: 22
    },
    {
      x: 6,
      y: 21
    },
    {
      x: 6,
      y: 20
    },
    {
      x: 6,
      y: 19
    },
    {
      x: 6,
      y: 18
    },
    {
      x: 8,
      y: 23
    },
    {
      x: 9,
      y: 23
    },
    {
      x: 10,
      y: 23
    },
    {
      x: 10,
      y: 22
    },
    {
      x: 11,
      y: 22
    },
    {
      x: 6,
      y: 5
    },
    {
      x: 7,
      y: 5
    },
    {
      x: 8,
      y: 6
    },
    {
      x: 8,
      y: 7
    },
    {
      x: 8,
      y: 8
    },
    {
      x: 8,
      y: 9
    },
    {
      x: 8,
      y: 10
    },
    {
      x: 8,
      y: 11
    },
    {
      x: 9,
      y: 11
    },
    {
      x: 9,
      y: 10
    },
    {
      x: 9,
      y: 9
    },
    {
      x: 9,
      y: 8
    },
    {
      x: 9,
      y: 7
    },
    {
      x: 9,
      y: 6
    },
    {
      x: 13,
      y: 5
    },
    {
      x: 13,
      y: 6
    },
    {
      x: 13,
      y: 7
    },
    {
      x: 13,
      y: 8
    },
    {
      x: 13,
      y: 9
    },
    {
      x: 13,
      y: 10
    },
    {
      x: 13,
      y: 11
    },
    {
      x: 14,
      y: 5
    },
    {
      x: 14,
      y: 6
    },
    {
      x: 14,
      y: 7
    },
    {
      x: 14,
      y: 8
    },
    {
      x: 14,
      y: 9
    },
    {
      x: 14,
      y: 10
    },
    {
      x: 14,
      y: 11
    },
    {
      x: 17,
      y: 5
    },
    {
      x: 17,
      y: 6
    },
    {
      x: 17,
      y: 7
    },
    {
      x: 17,
      y: 9
    },
    {
      x: 17,
      y: 10
    },
    {
      x: 18,
      y: 10
    },
    {
      x: 18,
      y: 11
    },
    {
      x: 18,
      y: 6
    },
    {
      x: 18,
      y: 7
    },
    {
      x: 20,
      y: 11
    },
    {
      x: 20,
      y: 10
    },
    {
      x: 20,
      y: 9
    },
    {
      x: 20,
      y: 8
    },
    {
      x: 20,
      y: 7
    },
    {
      x: 21,
      y: 6
    },
    {
      x: 21,
      y: 8
    },
    {
      x: 21,
      y: 7
    },
    {
      x: 21,
      y: 9
    },
    {
      x: 21,
      y: 10
    },
    {
      x: 21,
      y: 11
    },
    {
      x: 22,
      y: 5
    },
    {
      x: 23,
      y: 5
    },
    {
      x: 24,
      y: 6
    },
    {
      x: 24,
      y: 7
    },
    {
      x: 24,
      y: 8
    },
    {
      x: 24,
      y: 9
    },
    {
      x: 24,
      y: 10
    },
    {
      x: 24,
      y: 11
    },
    {
      x: 25,
      y: 11
    },
    {
      x: 25,
      y: 10
    },
    {
      x: 25,
      y: 9
    },
    {
      x: 25,
      y: 8
    },
    {
      x: 25,
      y: 7
    },
    {
      x: 22,
      y: 9
    },
    {
      x: 23,
      y: 9
    },
    {
      x: 27,
      y: 5
    },
    {
      x: 28,
      y: 5
    },
    {
      x: 29,
      y: 5
    },
    {
      x: 30,
      y: 5
    },
    {
      x: 31,
      y: 5
    },
    {
      x: 32,
      y: 5
    },
    {
      x: 28,
      y: 6
    },
    {
      x: 27,
      y: 6
    },
    {
      x: 28,
      y: 7
    },
    {
      x: 27,
      y: 7
    },
    {
      x: 28,
      y: 8
    },
    {
      x: 27,
      y: 8
    },
    {
      x: 28,
      y: 9
    },
    {
      x: 27,
      y: 9
    },
    {
      x: 28,
      y: 10
    },
    {
      x: 27,
      y: 10
    },
    {
      x: 27,
      y: 11
    },
    {
      x: 28,
      y: 11
    },
    {
      x: 34,
      y: 5
    },
    {
      x: 35,
      y: 5
    },
    {
      x: 34,
      y: 6
    },
    {
      x: 35,
      y: 6
    },
    {
      x: 34,
      y: 7
    },
    {
      x: 35,
      y: 7
    },
    {
      x: 35,
      y: 8
    },
    {
      x: 34,
      y: 8
    },
    {
      x: 34,
      y: 9
    },
    {
      x: 35,
      y: 9
    },
    {
      x: 34,
      y: 10
    },
    {
      x: 35,
      y: 10
    },
    {
      x: 34,
      y: 11
    },
    {
      x: 35,
      y: 11
    },
    {
      x: 41,
      y: 5
    },
    {
      x: 42,
      y: 5
    },
    {
      x: 42,
      y: 6
    },
    {
      x: 43,
      y: 6
    },
    {
      x: 42,
      y: 7
    },
    {
      x: 43,
      y: 7
    },
    {
      x: 42,
      y: 8
    },
    {
      x: 43,
      y: 8
    },
    {
      x: 42,
      y: 9
    },
    {
      x: 43,
      y: 9
    },
    {
      x: 42,
      y: 10
    },
    {
      x: 43,
      y: 10
    },
    {
      x: 42,
      y: 11
    },
    {
      x: 41,
      y: 11
    },
    {
      x: 46,
      y: 6
    },
    {
      x: 46,
      y: 7
    },
    {
      x: 46,
      y: 8
    },
    {
      x: 46,
      y: 9
    },
    {
      x: 46,
      y: 10
    },
    {
      x: 47,
      y: 5
    },
    {
      x: 47,
      y: 6
    },
    {
      x: 47,
      y: 7
    },
    {
      x: 47,
      y: 8
    },
    {
      x: 47,
      y: 9
    },
    {
      x: 47,
      y: 10
    },
    {
      x: 47,
      y: 11
    },
    {
      x: 48,
      y: 5
    },
    {
      x: 48,
      y: 11
    },
    {
      x: 49,
      y: 5
    },
    {
      x: 49,
      y: 11
    },
    {
      x: 50,
      y: 5
    },
    {
      x: 50,
      y: 6
    },
    {
      x: 50,
      y: 10
    },
    {
      x: 50,
      y: 11
    },
    {
      x: 51,
      y: 6
    },
    {
      x: 51,
      y: 10
    },
    {
      x: 53,
      y: 23
    }
  ]
};
